import { tagTone } from '@/features/projects/lib/tag-tone'
import { Badge } from '@/shared/components/ui/badge'
import { Button } from '@/shared/components/ui/button'
import type { ProjectTag } from '@/shared/types/domain'

interface TagFilterBarProps {
  tags: ProjectTag[]
  selectedIds: string[]
  onToggle: (tagId: string) => void
  onReset: () => void
}

export function TagFilterBar({ tags, selectedIds, onToggle, onReset }: TagFilterBarProps) {
  if (tags.length === 0) return null

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      {tags.map((tag) => {
        const active = selectedIds.includes(tag.id)

        return (
          <button
            // Явный label, а не текст внутри: иначе имя чипа совпадает с крестиком
            // «Убрать тег …» на карточке и запросы в тестах становятся неоднозначными.
            aria-label={`Фильтр по тегу ${tag.name}`}
            aria-pressed={active}
            key={tag.id}
            onClick={() => onToggle(tag.id)}
            title={tag.name}
            type="button"
          >
            <Badge
              badgeStyle={active ? 'solid' : 'subtle'}
              className="max-w-[14rem] cursor-pointer"
              tone={tagTone(tag.name)}
            >
              <span className="truncate">{tag.name}</span>
              {typeof tag.projects_count === 'number' ? (
                <span className="opacity-70">{tag.projects_count}</span>
              ) : null}
            </Badge>
          </button>
        )
      })}

      {selectedIds.length > 0 ? (
        <Button onClick={onReset} variant="ghost">
          Сбросить
        </Button>
      ) : null}
    </div>
  )
}
